import { InputWithLabel } from '@adotel/components'
import { FormikErrors, FormikTouched } from 'formik'
import React from 'react'

import { getTranslate } from '../../localization'
import { Gateway } from '../../types/gateway'
import useStyles from './styles/GatewayCredentialSwitch.styles'

interface GatewayCredentialSwitchProps {
  values: Gateway
  setFieldValue: (
    field: string,
    value: any,
    shouldValidate?: boolean | undefined
  ) => void
  errors: FormikErrors<Gateway>
  touched: FormikTouched<Gateway>
  handleBlur: {
    (e: React.FocusEvent<any, Element>): void
    <T = any>(fieldOrEvent: T): T extends string ? (e: any) => void : void
  }
  isSubmitting: boolean
  credentialMode: string
}

const GatewayCredentialSwitch: React.FC<GatewayCredentialSwitchProps> = ({
  values,
  setFieldValue,
  errors,
  touched,
  handleBlur,
  isSubmitting,
  credentialMode
}) => {
  const classes = useStyles()
  if (credentialMode === 'MerchantID') {
    return (
      <div className={classes.api}>
        <InputWithLabel
          placeholder={getTranslate('Enter Merchant Id')}
          label="Merchant Id"
          inputSize="small"
          value={values.credentialModeDetails.merchantId}
          name="credentialModeDetails.merchantId"
          id="credentialModeDetails.merchantId"
          onChange={(event) =>
            setFieldValue(
              'credentialModeDetails.merchantId',
              event.currentTarget.value
            )
          }
          error={
            (touched.credentialModeDetails?.merchantId &&
              !!errors.credentialModeDetails?.merchantId) ||
            undefined
          }
          helpertext={
            touched.credentialModeDetails?.merchantId
              ? getTranslate(errors.credentialModeDetails?.merchantId || '')
              : undefined
          }
          onBlur={handleBlur}
          disabled={isSubmitting}
        />
      </div>
    )
  } else if (credentialMode === 'ApiKey') {
    return (
      <div className={classes.api}>
        <InputWithLabel
          placeholder={getTranslate('Enter Api Key')}
          label="Api Key"
          inputSize="small"
          value={values.credentialModeDetails.apiKey}
          name="credentialModeDetails.apiKey"
          id="credentialModeDetails.apiKey"
          onChange={(event) =>
            setFieldValue(
              'credentialModeDetails.apiKey',
              event.currentTarget.value
            )
          }
          error={
            (touched.credentialModeDetails?.apiKey &&
              !!errors.credentialModeDetails?.apiKey) ||
            undefined
          }
          helpertext={
            touched.credentialModeDetails?.apiKey
              ? getTranslate(errors.credentialModeDetails?.apiKey || '')
              : undefined
          }
          onBlur={handleBlur}
          disabled={isSubmitting}
        />
      </div>
    )
  } else if (credentialMode === 'TerminalId') {
    return (
      <div className={classes.api}>
        <InputWithLabel
          placeholder={getTranslate('Enter Terminal Id')}
          label="Terminal Id"
          inputSize="small"
          value={values.credentialModeDetails.terminalId}
          name="credentialModeDetails.terminalId"
          id="credentialModeDetails.terminalId"
          onChange={(event) =>
            setFieldValue(
              'credentialModeDetails.terminalId',
              event.currentTarget.value
            )
          }
          error={
            (touched.credentialModeDetails?.terminalId &&
              !!errors.credentialModeDetails?.terminalId) ||
            undefined
          }
          helpertext={
            touched.credentialModeDetails?.terminalId
              ? getTranslate(errors.credentialModeDetails?.terminalId || '')
              : undefined
          }
          onBlur={handleBlur}
          disabled={isSubmitting}
        />
        <InputWithLabel
          placeholder={getTranslate('Enter Username')}
          label={getTranslate('Username')}
          inputSize="small"
          value={values.credentialModeDetails.username}
          name="credentialModeDetails.username"
          id="credentialModeDetails.username"
          onChange={(event) =>
            setFieldValue(
              'credentialModeDetails.username',
              event.currentTarget.value
            )
          }
          error={
            (touched.credentialModeDetails?.username &&
              !!errors.credentialModeDetails?.username) ||
            undefined
          }
          helpertext={
            touched.credentialModeDetails?.username
              ? getTranslate(errors.credentialModeDetails?.username || '')
              : undefined
          }
          onBlur={handleBlur}
          disabled={isSubmitting}
        />
        <InputWithLabel
          placeholder={getTranslate('Enter Password')}
          type="password"
          label={getTranslate('Password')}
          inputSize="small"
          value={values.credentialModeDetails.password}
          name="credentialModeDetails.password"
          id="credentialModeDetails.password"
          onChange={(event) =>
            setFieldValue(
              'credentialModeDetails.password',
              event.currentTarget.value
            )
          }
          error={
            (touched.credentialModeDetails?.password &&
              !!errors.credentialModeDetails?.password) ||
            undefined
          }
          helpertext={
            touched.credentialModeDetails?.password
              ? getTranslate(errors.credentialModeDetails?.password || '')
              : undefined
          }
          onBlur={handleBlur}
          disabled={isSubmitting}
        />
      </div>
    )
  } else if (credentialMode === 'UsernamePassword') {
    return (
      <div className={classes.api}>
        <InputWithLabel
          placeholder={getTranslate('Enter Username')}
          label={getTranslate('Username')}
          inputSize="small"
          value={values.credentialModeDetails.username}
          name="credentialModeDetails.username"
          id="credentialModeDetails.username"
          onChange={(event) =>
            setFieldValue(
              'credentialModeDetails.username',
              event.currentTarget.value
            )
          }
          error={
            (touched.credentialModeDetails?.username &&
              !!errors.credentialModeDetails?.username) ||
            undefined
          }
          helpertext={
            touched.credentialModeDetails?.username
              ? getTranslate(errors.credentialModeDetails?.username || '')
              : undefined
          }
          onBlur={handleBlur}
          disabled={isSubmitting}
        />
        <InputWithLabel
          placeholder={getTranslate('Enter Password')}
          type="password"
          label={getTranslate('Password')}
          inputSize="small"
          value={values.credentialModeDetails.password}
          name="credentialModeDetails.password"
          id="credentialModeDetails.password"
          onChange={(event) =>
            setFieldValue(
              'credentialModeDetails.password',
              event.currentTarget.value
            )
          }
          error={
            (touched.credentialModeDetails?.password &&
              !!errors.credentialModeDetails?.password) ||
            undefined
          }
          helpertext={
            touched.credentialModeDetails?.password
              ? getTranslate(errors.credentialModeDetails?.password || '')
              : undefined
          }
          onBlur={handleBlur}
          disabled={isSubmitting}
        />
      </div>
    )
  } else {
    return <></>
  }
}
export default GatewayCredentialSwitch
